import EnvironmentManager from 'Utils/environmentManager';
export const replaceUrlWithPublicUrl = (user, url) =>  {
  const tribun_land_nonlogin = EnvironmentManager.getMessageText({ key: 'tribun_land_nonlogin' }) === 'true';
  if (user?.userId ) {
    return url;
  } else {
    if (url) {
      if (tribun_land_nonlogin) {
        const newUrl = url.replace('mobile/tribun', 'mobile/tribun/public');
        return newUrl;
      } else {
        return url;
      }
    } else {
      return null;
    }
  }

};
